import React, { PureComponent } from 'react';

interface ClockIconProps {
  hour: any;
  minutes: any;
  className?: string;
  [key: string]: any;
}

class ClockIcon extends PureComponent<ClockIconProps> {
  render() {
    let hourDegrees = Math.floor((this.props.hour / 12) * 360 - 90);
    const minutesDegrees = Math.floor((this.props.minutes / 60) * 360);
    if (hourDegrees === 270 || (hourDegrees === 90 && minutesDegrees === 180)) {
      hourDegrees += 4;
    }
    const hourRotation = hourDegrees + 'deg';
    const minutesRotation = minutesDegrees + 'deg';
    // tslint:disable
    return (
      <svg viewBox="0 0 19 19" {...this.props}>
        <g>
          <path d="M9.49999999,0 C14.7364043,0 19,4.25965167 19,9.5 C19,14.7408815 14.7366749,19 9.49999999,19 C4.2633251,19 0,14.7408815 0,9.5 C0,4.25965167 4.26359567,0 9.49999999,0 Z M9.49999999,1.03198709 C4.82049136,1.03198709 1.0153505,4.83360804 1.0153505,9.5 C1.0153505,14.1669105 4.82020703,17.9680129 9.49999999,17.9680129 C14.1797929,17.9680129 17.9846495,14.1669105 17.9846495,9.5 C17.9846495,4.83360804 14.1795086,1.03198709 9.49999999,1.03198709 Z" />
          <path
            style={{
              transformOrigin: 'center',
              transform: `rotate(${hourRotation})`,
            }}
            d="M9.4863635,9.99999999 C9.21775235,9.99999999 9,9.77614239 9,9.5 C9,9.22385762 9.21775235,9 9.4863635,9 L14.7136363,9 C14.9822475,9 15.1999998,9.22385762 15.1999998,9.5 C15.1999998,9.77614239 14.9822475,9.99999999 14.7136363,9.99999999 L9.4863635,9.99999999 Z"
          />
          <path
            style={{
              transformOrigin: 'center',
              transform: `rotate(${minutesRotation})`,
            }}
            d="M9,2.52730317 C9,2.23608166 9.22385762,2 9.5,2 C9.77614237,2 10,2.23608166 10,2.52730317 L10,9.47269684 C10,9.76391836 9.77614237,10 9.5,10 C9.22385762,10 9,9.76391836 9,9.47269684 L9,2.52730317 Z"
          />
        </g>
      </svg>
    );
    // tslint:enable
  }
}

export default ClockIcon;
